:host {
  /**
    * @prop --collapse-item-font-size: font-size applied for both summary and detail content.
    * @prop --collapse-item-summary-font-size: font-size applied to summary only.
    * @prop --collapse-item-detail-font-size: font-size applied to detail only.
    */
  --collapse-item-font-size: var(--joy-font-size-primary-300);
  --collapse-item-transition: var(--joy-transition-duration-default);
  display: block;
}

@mixin markerStyle() {
  cursor: pointer;
  color: var(--joy-color-neutral-40);
  transform-origin: center;
  transition: transform var(--collapse-item-transition) var(--joy-transition-timing-function);
}

@mixin summaryStyle() {
  display: flex;
  align-items: center;
  gap: var(--joy-core-spacing-2);
}

.joy-collapse-item {
  display: flex;
  flex-direction: column;
  font-family: var(--joy-font-family-base);

  &__summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--joy-core-spacing-3);
    font-size: var(--collapse-item-summary-font-size, var(--collapse-item-font-size));
    font-weight: var(--joy-font-weight-bold);

    .joy-collapse-item__summary___marker {
      @include markerStyle();
    }

    &___content, ::slotted([slot="collapse-summary"]) {
      @include summaryStyle();
    }
  }

  &__summary,
  &__more {
    cursor: pointer;
    position: relative;
    z-index: 1;
  }

  &__detail {
    display: none;
    position: relative;
    height: auto;
    transition: height var(--collapse-item-transition) ease-in-out;
    font-size: var(--collapse-item-detail-font-size, var(--collapse-item-font-size));
    font-weight: var(--joy-font-weight-normal);

    &--open {
      display: block;
      margin-bottom: var(--joy-core-spacing-3);
    }
  }

  ::slotted(joy-icon[slot="collapse-marker"]) {
    cursor: pointer;
    color: var(--joy-color-neutral-40);
    transform-origin: center;
    transition: transform var(--collapse-item-transition) var(--joy-transition-timing-function);
  }

  &--open {
    ::slotted(joy-icon[slot="collapse-marker"]),
    .joy-collapse-item__summary___marker {
      transform: rotate(180deg);
    }
  }

  &--see-more {
    .joy-collapse-item__summary {
      order: 2;
    }

    .joy-collapse-item__detail {
      order: 1;
    }
  }
}

::slotted(*) {
  padding: 0;
  margin: 0;
}